interface ShimmerProps {
  className?: string;
}

const Shimmer = ({ className = "" }: ShimmerProps) => {
  return (
    <div className={`relative overflow-hidden bg-primary-subtle rounded ${className}`}>
      <div className="absolute inset-0 -translate-x-full animate-[shimmer_1.5s_infinite] bg-gradient-to-r from-transparent via-white/10 to-transparent" />
      <style>
        {`
          @keyframes shimmer {
            100% { transform: translateX(100%); }
          }
        `}
      </style>
    </div>
  );
};

export default Shimmer;